// extracted by mini-css-extract-plugin
export default {"container":"header_container__wkRv8","heading":"header_heading__-LcXq"};